



















import {Component, Prop, Vue} from "vue-property-decorator";
import StubCmp from "@/components/StubCmp.vue";

@Component({
  components: {StubCmp}
})
export default class HomeNews extends Vue  {
  @Prop({default: "Новости"}) public readonly blockTitle!: string;
  @Prop({default: "fa-newspaper"}) public readonly blockIcon!: string;
}
